import PolicyHistoryPanel from 'ApplicationEntry/components/WorkFlow/PolicyHistoryPanel';
import {getPolicyHistory} from 'ApplicationEntry/ducks/policyHistory';
import {matchAsync} from 'Core/models/Async';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import ErrorPage from 'Shared/components/ErrorPage';
import Loading from 'Shared/components/Loading';
import './WorkFlow.sass';

const PolicyHistory = () => {
  const dispatch = useDispatch();

  const {policyHistory} = useSelector((state: ReducerState) => state);

  useEffect(() => {
    dispatch(getPolicyHistory());
  }, [dispatch]);

  return (
    <div className="policy-history">
      {matchAsync(policyHistory, {
        Loaded: policyHistoryDetails => <PolicyHistoryPanel policyHistoryItems={policyHistoryDetails} />,
        Loading: () => <Loading />,
        Conflict: error => <ErrorPage error={error} />,
        ServerError: error => <ErrorPage error={error} />,
        Unauthorized: error => <ErrorPage error={error} />,
      })}
    </div>
  );
};

export default PolicyHistory;
